module.exports = __webpack_public_path__ + "img/HomePage-IT.c90d8d1.webp";